import { render, staticRenderFns } from "./vwRevenuesPerPeriod.vue?vue&type=template&id=4c548126&"
import script from "./vwRevenuesPerPeriod.vue?vue&type=script&lang=js&"
export * from "./vwRevenuesPerPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports